__turbopack_context__.v({
  "icon": "NaRIza_icon",
  "line": "NaRIza_line",
});
